export const getSessionData = (sessionKey) =>{
  const obj = sessionStorage.getItem(sessionKey)
  return obj === null ? null : JSON.parse(obj)
}
export const getLocalData = (sessionKey) =>{
  const obj = localStorage.getItem(sessionKey)
  return obj === null ? null : obj
}
export const setSessionData = (localKey, data) =>{
  const result = JSON.stringify(data)
  sessionStorage.setItem(localKey, result)
}
export const removeSessionData = (localKey) =>{
  sessionStorage.removeItem(localKey)
}